import Link from 'next/link';
import {GrFormNext, GrPrevious} from 'react-icons/gr';

const Pagination = ({total, page, maxpages, path})=>{
    return  <div className="container pagination marginBottom">
        <span className="paginationNext">
            {(page-1 > 0) &&  <Link href={`${path}${page-1}`}><a><GrPrevious/> Anterior</a></Link> }
        </span>
        <div className="paginationResume">
            <span>Página</span>
            <span className="paginationNumber">{page}</span>
            <span>de</span>
            <span>{total}</span>
        </div>
        <span className="paginationNext">
            {(page+1 <= maxpages) &&  <Link href={`${path}${page+1}`}><a>Siguiente <GrFormNext/></a></Link> }

        </span>
    </div>

};

export default Pagination;